/**
 * Number formatting utility functions
 */

/**
 * Formats a number with thousands separators (commas)
 * @param value - The number to format
 * @returns Formatted number string with commas
 * @example
 * formatNumberWithCommas(2111) // returns "2,111"
 * formatNumberWithCommas(15000) // returns "15,000"
 * formatNumberWithCommas(0) // returns "0"
 * formatNumberWithCommas(null) // returns "0"
 * formatNumberWithCommas(undefined) // returns "0"
 */
export function formatNumberWithCommas(
  value: number | null | undefined
): string {
  if (value === null || value === undefined || isNaN(value)) {
    return '0';
  }

  return value.toLocaleString('en-US');
}

/**
 * Parses a formatted number string back to a number
 * @param formattedValue - The formatted number string
 * @returns The parsed number
 * @example
 * parseFormattedNumber("2,111") // returns 2111
 * parseFormattedNumber("15,000") // returns 15000
 */
export function parseFormattedNumber(formattedValue: string): number {
  if (!formattedValue || formattedValue.trim() === '') {
    return 0;
  }

  // Remove commas and parse as number
  const cleanValue = formattedValue.replace(/,/g, '');
  const parsed = parseFloat(cleanValue);

  return isNaN(parsed) ? 0 : parsed;
}
